import { render, staticRenderFns } from "./PlanMessages.vue?vue&type=template&id=52c78a12&scoped=true&"
import script from "./PlanMessages.vue?vue&type=script&lang=js&"
export * from "./PlanMessages.vue?vue&type=script&lang=js&"
import style0 from "./PlanMessages.vue?vue&type=style&index=0&id=52c78a12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c78a12",
  null
  
)

export default component.exports